<template>
  <div class="single-product-teaser__container">
    <div class="single-product-teaser">
      <div
        v-if="featuredOffer?.teaserImage"
        class="single-product-teaser__image"
      >
        <GoliathImageElement
          :alt="featuredOffer?.teaserImage?.name"
          :image="featuredOffer.teaserImage"
          sm-width="medium"
        />
      </div>
      <div
        v-if="featuredOffer?.product"
        class="single-product-teaser__content"
      >
        <div>
          <Heading
            text-uppercase
            size="md"
            font-weight="ultra"
            align="left"
            tag="h2"
            class="single-product-teaser__content-heading"
          >
            {{ featuredOffer.product.name }}
          </Heading>

          <Paragraph class="single-product-teaser__content-description"
            >{{ descriptionPreview }}
          </Paragraph>
        </div>
        <div
          v-if="featuredOffer?.teaserImage"
          class="single-product-teaser__content-image"
        >
          <GoliathImageElement
            :alt="featuredOffer?.teaserImage?.name"
            :image="featuredOffer.teaserImage"
          />
        </div>

        <div class="single-product-teaser__buttons">
          <AddToCartButtonContainer
            v-if="featuredOffer"
            :offer="featuredOffer"
            :display-icon="false"
          />

          <LinkButton
            :to="`/geraete/${featuredOffer?.product?.slug}`"
            tag="nuxt-link"
            outline-light
          >
            Mehr erfahren
          </LinkButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Heading,
  LinkButton,
  Paragraph,
  GoliathImageElement,
} from '@i22-td-smarthome/component-library';
import AddToCartButtonContainer from '~/components/product-detail/add-to-cart-button-container.vue';

export default {
  name: 'SingleProductTeaser',
  components: {
    AddToCartButtonContainer,
    Heading,
    LinkButton,
    Paragraph,
    GoliathImageElement,
  },
  props: {
    featuredOffer: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    descriptionPreview() {
      return this.featuredOffer?.usps?.length > 0
        ? `${this.featuredOffer.usps[0]}. ${this.featuredOffer.usps[1]}...`
        : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.single-product-teaser {
  flex-direction: column;
  padding: $grid-base * 3 $grid-base * 2;
  @include mq($mq-sm) {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    position: relative;
  }

  &__container {
    --bg-image--md: url('/content/content-images/treueshop/single-prod-teaser/365661d0b9cc48876e2b3e48df3e0354/aktionsteaser-einzelaktion@2x.jpg');
    --bg-image--sm: url('/content/content-images/treueshop/single-prod-teaser/5c62e0b466f3ac11794b9612121f06d2/aktionsteaser-einzelaktion-mobil@2x.jpg');
    width: 100%;
    background-image: var(--bg-image--sm);
    background-position: 33% center;
    background-repeat: no-repeat;
    background-size: cover;
    margin: 7 * $grid-base 0;

    @include mq($mq-sm) {
      background-image: var(--bg-image--md);
      max-width: $mq-lpg-lg-width;
      margin: 7 * $grid-base auto;
    }
  }
  &__image {
    display: none;
    @include mq($mq-sm) {
      width: 40%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    :deep(img) {
      width: 300px;
    }
  }
  &__content {
    width: 40%;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include mq(false, $mq-sm - 1) {
      width: 100%;
      text-align: center;
      align-items: center;
    }

    &-heading {
      text-align: center;
      color: white;
      margin-bottom: $grid-base;
      @include mq($mq-sm) {
        text-align: left;
        margin-bottom: $grid-base * 2;
      }
    }
    &-description {
      grid-area: description;
      text-align: center;
      @include mq($mq-sm) {
        margin-bottom: $grid-base * 1.5;
        text-align: left;
      }
    }
    &-image {
      display: none;
      @include mq(false, $mq-sm - 1) {
        display: block;
      }

      :deep(img) {
        width: 180px;
      }
    }
  }
  &__buttons {
    display: flex;
    gap: $grid-base;

    @include mq(false, $mq-sm - 1) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: $grid-base;
    }
  }
}
</style>
